import React from "react";
import CalendarDay from './CalendarDay';
import { format } from "date-fns";

const CalendarTable = (props) => {
    const {weekDays,index,calendarData} = props;
    return(<table>
            <thead>
                {!index ? <tr>
                    {weekDays.map((day,k)=>(<th key={k} >{format(day,'cccc')}</th>))}
                </tr>:''}
                <tr>
                    {weekDays.map((day,k)=>(<th key={k} >{format(day,'MMMM d, yyyy')}</th>))}
                </tr>
            </thead>
            <tbody>
                <tr>
                    {weekDays.map((day,k)=>(<CalendarDay key={k} day={day} calendarData={calendarData}  />))}
                </tr>
            </tbody>
        </table>);

}

export default CalendarTable;